import { React, useEffect, useState } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { Redirect, useParams, withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { MobileHighlightPage, MobileButton, MobileReverseButton } from "../../../components";
import MyQuotientChart from "./MyQuotientChart";

import { checkSignedIn } from "../../../services/auth.service";
import Cookies from 'universal-cookie';


const cookies = new Cookies();
const useStyles = makeStyles((theme) => ({
    title: {
        margin: 30
    },
    boldSubtitle: {
        fontWeight: 'bold'
    },
    chart: {
        marginTop: 30
    },
    saveButton: {
        width: '75%',
        marginBottom: theme.spacing(1)
    },
    resetButton: {
        width: '75%',
    },
    footer: {
        marginTop: 'auto',
        marginBottom: '20px',
        width: '100%'
    },
}));

const MyQuotient = props => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { curChildren, desChildren, bioChildren } = useParams();
    const [resetValues, setResetValues] = useState(false);
    const [healthProfile, setHealthProfile] = useState();

    useEffect(() => {
        const getHealthProfile = async () => {
            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_PROFILE}`, {
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    }
                });
                if (!response) return;
                let json = await response.json();
                setHealthProfile(json);
            } catch (error) {
                console.log(error);
            }
        };

        getHealthProfile();
    }, []);

    const zoneText = (curChildren, desChildren) => {
        if (desChildren > curChildren) return t('fpqChart.zoneGreen');
        if (desChildren < curChildren) return t('fpqChart.zonePurple');
        return t('fpqChart.blueLine');
    }

    const handleResetValues = () => {
        setResetValues(true);
    }

    const handleSaveProfile = async () => {
        try {
            let isSignedIn = await checkSignedIn();
            if (!isSignedIn) {
                if (curChildren) localStorage.setItem('fpqCurrentChildren', curChildren);
                if (desChildren) localStorage.setItem('fpqDesiredChildren', desChildren);
                if (bioChildren) localStorage.setItem('fpqBiologicalChildren', bioChildren);
            } else {
                await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_SAVEFPQ}`, {
                    method: 'post',
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    },
                    body: new URLSearchParams({
                        curChildren: curChildren,
                        desChildren: desChildren,
                        bioChildren: bioChildren
                    })
                });
            }
            props.history.push('/app/signin');
        } catch (error) {
            console.log(error);
        }
    }

    if (resetValues) return <Redirect to="/app/fpqquestionary" />

    return (
        <MobileHighlightPage>
            <Typography variant="h3" className={classes.title}>{t('fpqChart.title')}</Typography>
            <Typography variant="h6" className={classes.boldSubtitle}>{t('fpqChart.zonePositionFixedText')} {zoneText(curChildren, desChildren)}.</Typography>
            <Typography variant="h6">{desChildren} {t('fpqChart.desiredChildrenFixedText')}, {curChildren} {t('fpqChart.currentChildrenFixedText')}.</Typography>
            <Box className={classes.chart}>
                <MyQuotientChart
                    currentChildren={curChildren || (healthProfile && healthProfile.currentChildren)}
                    desiredChildren={desChildren || (healthProfile && healthProfile.desiredChildren)} />
            </Box>
            <Box className={classes.footer}>
                <MobileButton
                    label={t('fpqChart.saveProfileButtonLabel')}
                    className={classes.saveButton}
                    onClick={handleSaveProfile} />
                <MobileReverseButton className={classes.resetButton}
                    onClick={handleResetValues}>{t('fpqChart.resetValuesButtonLabel')}</MobileReverseButton>
            </Box>
        </MobileHighlightPage>
    );
};

export default withRouter(MyQuotient);